<template>
<v-container class="container">
  <v-alert
    :value="showAlert"
    type="error"
    class="alert"
    transition="scale-transition"
  >Hubo un error al intentar guardar el dato</v-alert>
  <v-row justify="center" class="mb-12">
    <v-col cols="12" md="10">
      <v-card flat class="pa-4">
        <v-card-text>
          <p class="text-h5">
            Tablero Eléctrico
          </p>
          <v-form ref="form">
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="form.name"
                  label="Nombre Tablero"
                  placeholder="Ej: Tablero General"
                  :rules="fieldRules"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="form.ubication"
                  label="Ubicación"
                  placeholder="Ej: Sala principal"
                  :rules="fieldRules"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="form.InProteccion"
                  label="In Protección General (A)"
                  placeholder="Ej. 3 x 120"
                  :rules="fieldRules"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  v-model="form.conductors"
                  :items="conductorItems"
                  label="Conductores por Fase"
                  :rules="fieldRules"
                  required
                ></v-select>
              </v-col>
            </v-row>
    
            <v-row>
              <v-col cols="12" md="6">
                <v-select
                  v-model="form.feeder"
                  :items="feederItems"
                  label="Sección del Alimentador (mm2)"
                  :rules="fieldRules"
                  required
                ></v-select>
              </v-col>
            </v-row>
    
            <v-row>
              <v-col>
                <v-checkbox
                  v-model="form.fuseHolder"
                  label="Presencia de Portafusibles"
                ></v-checkbox>
              </v-col>
            </v-row>
    
            <v-row>
              <v-col>
                <v-checkbox
                  v-model="form.wifi"
                  label="Presencia de Redes Wifi"
                  class="text--primary"
                ></v-checkbox>
              </v-col>
            </v-row>
            <v-row v-if="form.wifi">
              <v-col>
                <v-select
                  v-model="form.wifiIntensity"
                  :items="intensityItems"
                  label="Seccione la Intensidad de la Red Wifi"
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-checkbox
                  v-model="form.mobile"
                  label="Presencia de Señal 3G/4G"
                ></v-checkbox>
              </v-col>
            </v-row>
            <v-row v-if="form.mobile">
              <v-col>
                <v-select
                  v-model="form.mobileIntensity"
                  :items="intensityItems"
                  label="Seccione la Intensidad de la señal"
                ></v-select>
              </v-col>
            </v-row>
            <v-row v-if="form.mobile">
              <v-col>
                <v-select
                  v-model="form.mobileSupplier"
                  :items="mobileSupplierItems"
                  label="Proveedor 3G/4G"
                ></v-select>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
  <Footer
    :currentStep="1"
    :loadingForward="loadingForward"
    :loadingBackward="loadingBackward"
    @nextStep="handleNextStep($event)"
  />
</v-container>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import Footer from './footer.vue'

export default {
  name: 'ww-electric-board',
  components: { Footer },
  data() {
    return {
      loadingForward: false,
      loadingBackward: false,
      showAlert: false,
      form: {
        name: null,
        ubication: null,
        InProteccion: null,
        conductors: null,
        feeder: null,
        fuseHolder: false,
        wifi: false,
        wifiIntensity: null,
        mobile: null,
        mobileIntensity: null,
        mobileSupplier: null,
      },
      intensityItems: ['Baja', 'Media', 'Alta'],
      feederItems: [
        '0 - 6',
        '7 - 16',
        '17 - 25',
        '26 - 50',
        '51 - 120',
        '121 - 185',
        '186 - 300',
        '301 - 500',
        '501 - 630',
      ],
      mobileSupplierItems: [
        'Claro',
        'Entel',
        'Movistar',
        'Wom',
      ],
      fieldRules: [
        v => !!v || 'Este campo es requerido',
      ]
    }
  },
  mounted() {
    if (this.boardId) {
      const wizard = this.docs.find((item) => item._id === this.$route.params.wizardId)
      const board = wizard.boards.find((item) => item._id === this.boardId)
      if (board) this.form = board.electricBoard
    }
  },
  computed: {
    ...mapGetters({
      boardId: 'wizard/boardId',
      docs: 'wizard/docs',
    }),
    conductorItems() {
      const condutors = []
      for (let index = 1; index <= 10; index++) {
        condutors.push(index)
      }
      return condutors
    },
  },
  methods: {
    ...mapActions({
      storeElectricBoard: 'wizard/STORE_BOARD_DATA',
      updateElectricBoard: 'wizard/UPDATE_BOARD_DATA',
    }),
    async handleNextStep(event) {
      if (this.$refs.form.validate()) {
        const { step, direction } = event
        if (direction === 'forward') this.loadingForward = true
        if (direction === 'backward') this.loadingBackward = true

        try {
          if (!this.boardId) {
            await this.storeElectricBoard({
              form: { electricBoard: this.form },
              wizardId: this.$route.params?.wizardId ?? null,
            })
          } else {
            await this.updateElectricBoard({
              form: { electricBoard: this.form },
              boardId: this.boardId,
            })
          }
        } catch {
          this.showAlert = true
        } finally {
          this.$emit('nextStep', { nextStep: step, form: this.form })
          if (direction === 'forward') this.loadingForward = false
          if (direction === 'backward') this.loadingBackward = false
        }
      }
    },
  },
}
</script>
<style scoped>
.container {
  max-width: 1080px;
}
</style>
